import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EnterpriceSassComponent} from './LandingPage/enterprice-sass/enterprice-sass.component';
import { CheckoutComponent} from './ProductSearch/Finalisation/checkout/checkout.component';
import { ProfileComponent} from './UserPages/Profile/profile.component';
import { LoginComponent} from './UserPages/login/login.component';
import { SignUpComponent} from './UserPages/sign-up/sign-up.component';
import {PageNotFoundComponent} from './StaticSites/page-not-found/page-not-found.component';
import {ImpressumComponent} from './StaticSites/impressum/impressum.component';
import {ContactComponent} from './StaticSites/contact/contact.component';
import {AboutPage} from './StaticSites/ServicesPage/about-page.component';
import {LeadGeneationPageComponent} from './ProductSearch/LeadGeneration/lead-geneation-page/lead-geneation-page.component';
import {ListconfiguratorComponent} from './ProductSearch/ListConfiguration/listconfigurator/listconfigurator.component';
import {IndustryoverviewComponent} from './ProductSearch/industryoverview/industryoverview.component';
import {FaqPageComponent} from './StaticSites/FAQPage/faq-page/faq-page.component';
import {DatenschutzerklaerungComponent} from './StaticSites/datenschutzerklaerung/datenschutzerklaerung.component';
import {AgbsComponent} from './StaticSites/agbs/agbs.component';
import {EmailkampangeComponent} from './StaticSites/WhyPalladioPage/emailkampange/emailkampange.component';
import {FeaturePageComponent} from './StaticSites/FeaturePage/feature-page/feature-page.component';
import {RechtlichesComponent} from './StaticSites/DSGVO/rechtliches/rechtliches.component';
import {
  ThankYouForOrderPaypalComponent
} from './ProductSearch/Finalisation/ThankYouForOrder/thank-you-for-order-paypal/thank-you-for-order-paypal.component';
import {
  ThankYouForOrderBankComponent
} from './ProductSearch/Finalisation/ThankYouForOrder/thank-you-for-order-bank/thank-you-for-order-bank.component';

export const routes: Routes = [
  {
    path: '',
    component: EnterpriceSassComponent,
    pathMatch: 'full',
  },
  {
    path: 'anmelden',
    component: LoginComponent
  },
  {
    path: 'registrieren',
    component: SignUpComponent
  },
  {
    path: 'profil',
    component: ProfileComponent
  },
  {
    path: 'checkout',
    component: CheckoutComponent
  },
  {
    path: 'thank-you-paypal',
    component: ThankYouForOrderPaypalComponent
  },
  {
    path: 'thank-you-bank',
    component: ThankYouForOrderBankComponent
  },
  {
    path: 'tabelle-erstellen',
    component: LeadGeneationPageComponent
  },
  {
    path: 'impressum',
    component: ImpressumComponent,
  },
  {
    path: 'kontakt',
    component: ContactComponent,
  },
  {
    path: 'services',
    component: AboutPage,
  },
  {
    path: 'faq',
    component: FaqPageComponent,
  },
  {
    path: 'branchen-uebersicht',
    component: IndustryoverviewComponent,
  },
  {
    path: 'liste-konfigurieren',
    component: ListconfiguratorComponent,
  },
  {
    path: 'allgemeine-geschaefts-bedingungen',
    component: AgbsComponent,
  },
  {
    path: 'datenschutz',
    component: DatenschutzerklaerungComponent,
  },
  {
    path: 'warum-palladio',
    component: EmailkampangeComponent,
  },
  {
    path: 'features',
    component: FeaturePageComponent,
  },
  {
    path: 'dsgvo',
    component: RechtlichesComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // preloadingStrategy: PreloadAllModules,
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
